import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import logo from "../../assets/images/logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";




const ForgotPassword = () => {
    //const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [successResponse, setSuccessResponse] = useState(false);

    
    const [isOtp, setIsOtp] = useState(false);
    const [passEye, setPassEye] = useState(false);
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const passwordRegrx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    


    
    const [inputData, setInputData] = useState({
        email: "",
        otp:"",
        new_password:'',
        confirm_new_password:''
    });
    
    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(false);
        setSuccessResponse(false);


        const { email } = inputData;
        if (!email ) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);

            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/forgot-password", {
                email: email,
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        //Swal.fire({ icon: "success", title: "Email Sent", text: "Please check your emails for a message with your reset password code." });
                        setSuccessResponse("We have sent you an email with authentication code. Please enter this code along with your new password. ");
                        setInputData({ ...inputData, email: email,role:response?.data?.role })
                        setIsOtp(true);
                        
                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(false);
        setSuccessResponse(false);
        setInputError(false);

       
        const { email,otp,new_password,confirm_new_password,role } = inputData;
        if (!email || !otp || !new_password ||new_password !== confirm_new_password || !new_password.match(passwordRegrx )) {
            setInputError(true);
            setIsBtn(false)
           
        } else {

            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/reset-password", {
                email: email,
                otp: otp,
                role:role,
                new_password: new_password,
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        //Swal.fire({ icon: "success", title: "Email Sent", text: "Please check your emails for a message with your reset password code." });
                        setSuccessResponse(<span>Password updated successfully! <a href='/login'>Click here</a> to login.</span>);
                        setInputData({
                            email: "",
                            otp:"",
                            new_password:'',
                            confirm_new_password:''
                        })
                        setIsOtp(false);
                        
                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };
    
    return (
        <div className="card card-medium" >
            <div className="card-header">
                <img src={logo} alt="MedRecAps" />
            </div>
            <div className="card-body p-4">
                    {errorResponse &&
                    <div className="alert alert-danger" role="alert">
                         {errorResponse}
                    </div>
                    }
                   {successResponse &&
                    <div className="alert alert-success" role="alert">
                         {successResponse}
                    </div>
                    }
            {isOtp === false ?
            <form onSubmit={(e) => handleForgotPassword(e)}>
            <h3 className="text-center mb-5 text-primary">Forgot Password</h3>

              <div className="row">
                <div className="col-12">
                  <label>Email *</label>
                  <input type="text" className="form-control form-control-lg" placeholder="Email"
                    value={inputData.email} onChange={(e) => setInputData({ ...inputData, email: e.target.value })}
                  />
               {inputError &&
                      (!inputData.email ||
                        !emailRegex.test(inputData.email)) && (
                        <span className="text-danger">
                          {inputData.email && !emailRegex.test(inputData.email)
                            ? "Invalid email address"
                            : "This field is required"}
                        </span>
                      )}
                </div>
              </div>

              <div className=" text-center ">

                        <button type="submit" className="btn btn-lg btn-primary mt-3 mb-3 px-5" disabled={isBtn}>
                            {isBtn ? <Loading /> : 'Send Password Reset Email'}
                        </button>
                        <div >
                            <Link className="btn btn-link text-primary mt-5" to="/login">Go to Login Page</Link>
                        </div>
                    </div>
            </form>
            :
            <form onSubmit={(e) => handleResetPassword(e)}>
            <h3 className="text-center mb-5 text-primary">Enter Your New Password</h3>

              <div className="row">
                <div className="col-12">
                  <label>Enter code sent on your registered email *</label>
                  <input type="text" className="form-control form-control-lg" placeholder=""
                    value={inputData.otp} onChange={(e) => setInputData({ ...inputData, otp: e.target.value })}
                  />
               {inputError && !inputData.otp && (
                        <span className="text-danger">
                            This field is required
                        </span>
                      )}
                </div>
              </div>

              <div className="row mt-2">
                        <div className="col-12">
                            <label>New Password: *</label>

                            <div className="input-group">
                                <input type={`${!passEye ? `password` : `text`}`} className="form-control form-control-lg" id="new_password"
                                    name="new_password"  value={inputData.new_password}
                                    onChange={(e) =>
                                        setInputData({ ...inputData, new_password: e.target.value })
                                    } />
                                <span className="input-group-text">
                                    {(passEye) ? <FaEye onClick={() => setPassEye(!passEye)} /> : <FaEyeSlash onClick={() => setPassEye(!passEye)} />}
                                </span>
                            </div>


                            {inputError && !inputData.new_password && (
                                <span className="text-danger">This field is required</span>
                            )}
                             {inputError && !inputData?.new_password?.match(passwordRegrx ) && (
                                <span className="text-danger">Password must be minimum eight characters long and have at least one uppercase letter, one lowercase letter, one number and one special character.</span>
                            )}

                        </div>
                    </div>


                    <div className="row mt-2">
                        <div className="col-12">
                            <label>Confirm Password: *</label>

                            <div className="input-group">
                                <input type={`${!passEye ? `password` : `text`}`} className="form-control form-control-lg" id="confirm_new_password"
                                    name="confirm_new_password"  value={inputData.confirm_new_password}
                                    onChange={(e) =>
                                        setInputData({ ...inputData, confirm_new_password: e.target.value })
                                    } />
                                <span className="input-group-text">
                                    {(passEye) ? <FaEye onClick={() => setPassEye(!passEye)} /> : <FaEyeSlash onClick={() => setPassEye(!passEye)} />}
                                </span>
                            </div>


                            {inputData.new_password && inputError && (!inputData.confirm_new_password || inputData.new_password !== inputData.confirm_new_password) && (
                      <span className="text-danger">
                        {inputData.confirm_new_password && inputData.new_password !== inputData.confirm_new_password
                          ? "Your password and confirmation password do not match"
                          : "This field is required"}
                      </span>
                    )}

                        </div>
                    </div>




              <div className=" text-center ">

                        <button type="submit" className="btn btn-lg btn-primary mt-3 mb-3 px-5" disabled={isBtn}>
                            {isBtn ? <Loading /> : 'Change Password'}
                        </button>
                        <div >
                            <Link className="btn btn-link text-primary mt-5" to="/login">Go to Login Page</Link>
                        </div>
                    </div>
            </form>
                    }
        
            </div>
        </div>


    );
};

export default ForgotPassword;